"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSAddLineComponent = void 0;
const core_1 = require("@angular/core");
const addline_service_1 = require("../services/addline.service");
const generic_content_service_1 = require("../services/generic.content.service");
const account_service_1 = require("../services/account.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const ng_bootstrap_2 = require("@ng-bootstrap/ng-bootstrap");
const _ = require("underscore");
class CSAddLineComponent {
    constructor(addLineService, genericContentService, accountService, modalService) {
        this.addLineService = addLineService;
        this.genericContentService = genericContentService;
        this.accountService = accountService;
        this.modalService = modalService;
        this.isAddLine = false;
        this.isBusinessAccount = new core_1.EventEmitter();
        this.prepaidPrimaryPlansArray = [];
    }
    ngOnInit() {
        this.isPrimaryPlanExist = false;
        this.prepaidPrimaryPlansArray = ['NW_PAYG_6GB', 'NW_PAYG_12GB', 'NW_PAYG_6GB_SDR', 'NW_PAYG_12GB_SDR', 'NW_PAYG_25GB_SDR',
            'NW_PAYG_25GB', 'MLP_PAYG_6GB', 'MLP_PAYG_12GB', 'MLP_PAYG_25GB', 'MLP_PAYG_6GB_2', 'MLP_PAYG_12GB_2', 'MLP_PAYG_25GB_2',
            'MLP_PAYG_6GB_2_SDR', 'MLP_PAYG_12GB_2_SDR', 'MLP_PAYG_25GB_2_SDR'];
        this.getAccountDetailsInfo();
    }
    addLineEligbilityCall() {
        this.loader = true;
        if (this.isBusiness) {
            this.addLineService.getAddLineBusinessEligibility()
                .subscribe((data) => {
                this.loader = false;
                if (data != null && data.cartHasItem !== undefined) {
                    this.iscartHasItem = data.cartHasItem;
                }
                this.addLineEligibilityStatus = data;
                this.errorEmptyCart();
                this.checkAddLineEligibility();
            }, (err) => {
                this.loader = false;
                this.error = err;
            });
        }
        else {
            this.addLineService.getAddLineEligibility()
                .subscribe((data) => {
                this.loader = false;
                this.addLineEligibilityStatus = data;
                this.checkAddLineEligibility();
            }, (err) => {
                this.loader = false;
                this.error = err;
            });
        }
    }
    errorEmptyCart() {
        this.loader = true;
        this.genericContentService.getGenericContent('genericErrorEmptyCart').subscribe((data) => {
            this.cartErrorMsg = data.contentText;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loading = false;
        });
    }
    onCloseClick() {
        this.tooltip.close();
    }
    showToolTipContent() {
        if (this.isBusiness) {
            this.openToolTipWithContent('/generic/Business/blockAddALine');
        }
        else if (this.pastDueBalance <= '0.0') {
            this.openToolTipWithContent('genericContentBlockAddaline');
        }
        else {
            this.openToolTipWithContent('/generic/instructional/addLineBlocked');
        }
    }
    openToolTipWithContent(content) {
        this.loading = true;
        this.genericContentService.getGenericContent(content).subscribe((data) => {
            this.message = data;
            this.loading = false;
            this.tooltip.open();
        }, (err) => {
            this.error = err;
            this.loading = false;
        });
    }
    checkAddLineEligibility() {
        var _a, _b, _c, _d, _e;
        this.autoHidePopup = false;
        this.disableAddLine = false;
        if (this.pastDueBalance <= 0.0 && !((_a = this.addLineEligibilityStatus) === null || _a === void 0 ? void 0 : _a.addLineAllowed)) {
            if (!this.isFromUsage) {
                if (this.isBusiness && this.iscartHasItem) {
                    this.getClearCartPopUp();
                }
                else {
                    this.autoHidePopup = true;
                    this.showToolTipContent();
                }
            }
            else {
                if (!this.isPrepaid && !this.isBusiness) {
                    this.autoHidePopup = true;
                }
                else if (this.isPrepaid) {
                    this.disableAddLine = true;
                }
                this.showToolTipContent();
            }
        }
        else if (this.pastDueBalance > 0.0 && !((_b = this.addLineEligibilityStatus) === null || _b === void 0 ? void 0 : _b.addLineAllowed)) {
            if (this.isPrepaid) {
                this.disableAddLine = true;
            }
            this.showToolTipContent();
        }
        else if ((_c = this.addLineEligibilityStatus) === null || _c === void 0 ? void 0 : _c.addLineAllowed) {
            if (!((_d = this.addLineEligibilityStatus) === null || _d === void 0 ? void 0 : _d.hasDailyRatePlan) && !this.iscartHasItem) {
                this.navigate();
            }
            else if (this.isPrepaid && ((_e = this.addLineEligibilityStatus) === null || _e === void 0 ? void 0 : _e.hasDailyRatePlan)) {
                this.showPlanChangePopUp();
            }
            else {
                this.showToolTipContent();
            }
        }
        else {
            this.showToolTipContent();
        }
    }
    showPlanChangePopUp() {
        if (this.addLineEligibilityStatus.hasDailyRatePlan === true) {
            this.genericContentService.getGenericContent('genericDRPDisclaimer').subscribe((data) => {
                this.planDisclaimer = data.contentText;
                this.loading = false;
                this.open(this.planChangeContent);
            }, (err) => {
                this.error = err;
                this.loading = false;
            });
        }
    }
    navigate() {
        if (this.isBusiness) {
            window.location.href = '/my_account/business_account/bulk_maintenance/add_lines/add_lines.jsp';
        }
        else if (this.isPrepaid && this.profileType === 'PRIMARY' && this.isPrimaryPlanExist) {
            this.openPrepaidAddLine(this.addDevice);
        }
        else {
            if (this.offerUrl) {
                window.location.href = this.offerUrl + '?userAction=mmaAddLine';
            }
            else {
                window.location.href = '/buy/devices?userAction=mmaAddLine';
            }
        }
    }
    addPhoneOrTablet(device) {
        if (device === 'phone') {
            window.location.href = '/buy/devices?userAction=mmaAddLine';
        }
        else if (device === 'tablet') {
            window.location.href = '/buy/devices/tablet?userAction=mmaAddLine';
        }
    }
    openAddDevicePopUp(content) {
        this.modalRef = this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal' });
    }
    getAccountDetailsInfo() {
        this.accountService.getAccountDetails(true).subscribe((res) => {
            if (res.accountType === 'EMPLOYEE') {
                this.isAddLine = true;
            }
            this.pastDueBalance = res.pastDueBalance ? res.pastDueBalance : 0;
            this.isPrepaid = res.advancePayAccount;
            this.isBusiness = res.businessAccount;
            this.isBusinessAccount.emit(this.isBusiness);
            this.profileType = res.profileType;
            if (res.subscription) {
                this.subscriptions = res.subscription;
                for (let i = 0; i < this.subscriptions.length; i++) {
                    const planName = (this.subscriptions[i].plan && (this.subscriptions[i].plan.planName || this.subscriptions[i].plan.planDisplayName))
                        || this.subscriptions[i].planName;
                    if (_.contains(this.prepaidPrimaryPlansArray, planName)) {
                        this.isPrimaryPlanExist = true;
                    }
                }
            }
        });
    }
    open(content) {
        this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal' });
        window['closePopUp'] = function () {
            const event = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: true
            });
            document.querySelector('.close').dispatchEvent(event);
        };
    }
    openPrepaidAddLine(content) {
        this.modalRef = this.modalService.open(content, { size: 'sm', windowClass: 'dark-modal prepaid-model-popup', centered: true });
    }
    getClearCartPopUp() {
        this.open(this.clearCart);
    }
    cartClear() {
        this.loader = true;
        this.addLineService.clearCart()
            .subscribe((data) => {
            this.iscartHasItem = false;
            this.addLineEligibilityStatus.addLineAllowed = true;
            this.loader = false;
        }, (err) => {
            this.loader = false;
            this.error = err;
        });
    }
}
exports.CSAddLineComponent = CSAddLineComponent;
//# sourceMappingURL=addline.component.js.map